var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('header-component',{ref:"header",staticClass:"layout__header",attrs:{"currentLang":_vm.currentLang}}),_c('main',{staticClass:"layout__main"},[_vm._t("default")],2),_c('footer-component',{staticClass:"layout__footer",attrs:{"currentLang":_vm.currentLang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }